import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button, Paper } from '@material-ui/core';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
const messages = {
  400: ['This request could not be processed', 'Return to your profile and try again. Contact us if the same message returns.'],
  401: ['Please sign in again', 'Use the same account and sign-in method you used for your assessment.'],
  403: ['This page is not available to your account', 'Check that you are signed in to the correct account. An access error does not establish whether your assessment saved. Check your profile before repeating it.'],
  404: ['We could not find that page', 'The link may have changed. Choose one of the options below to continue.'],
};
export default function ErrorPage(props) {
  const location = useLocation();
  const code = new URLSearchParams(location.search).get('errCode') || 404;
  const [title, message] = messages[code] || messages[404];
  return <div><NavBar isLoggedIn={props.isLoggedIn} />
    <main className="emap-error-content"><Paper className="emap-error-card">
      <p className="emap-card-kicker">Error {code}</p><h2>{title}</h2><p>{message}</p>
      <div className="emap-error-actions"><Button component={Link} to={props.isLoggedIn ? '/profile' : '/login'} variant="contained" color="primary">{props.isLoggedIn ? 'Go to my profile' : 'Sign in'}</Button><Button component={Link} to="/faq" variant="outlined" color="primary">Help and FAQ</Button><Link to="/contact">Contact EntreMap</Link></div>
    </Paper></main><Footer /></div>;
}
